'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["avatarLookup", "children", "className", "companyId", "displayName", "domain", "email", "fetchAvatars", "hubSpotUserEmail", "lookup", "src", "type", "vid"];
import devLogger from 'react-utils/devLogger';
import pickToolTipName from './UIAvatarDisplay/pickToolTipName';
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import UIAvatar from './UIAvatar';
import UITag from 'UIComponents/tag/UITag';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIAvatarTag = styled(UITag).withConfig({
  displayName: "UIAvatarTag__StyledUIAvatarTag",
  componentId: "sc-1l5xoff-0"
})(["align-items:center;display:inline-flex !important;height:32px;"]);
class UIAvatarTag extends Component {
  render() {
    const _this$props = this.props,
      {
        avatarLookup,
        children,
        className,
        companyId,
        displayName,
        domain,
        email,
        fetchAvatars,
        hubSpotUserEmail,
        lookup,
        src,
        type,
        vid
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const lookupUnProxy = lookup || avatarLookup || {};
    if (avatarLookup) {
      devLogger.warn({
        message: 'UIAvatarTag avatarLookup prop is depreciated, please just use supply props directly or use lookup instead'
      });
    }
    return /*#__PURE__*/_jsx(StyledUIAvatarTag, Object.assign({}, rest, {
      _flexWrapperProps: {
        style: {
          alignItems: 'center'
        }
      },
      _avatar: /*#__PURE__*/_jsx(UIAvatar, {
        lookup: lookup || avatarLookup,
        companyId,
        email,
        domain,
        displayName,
        fetchAvatars,
        hubSpotUserEmail,
        vid,
        type,
        size: 'xs',
        src,
        className: 'm-right-1'
      }),
      className: className,
      children: children || pickToolTipName(lookupUnProxy) || displayName
    }));
  }
}
UIAvatarTag.defaultProps = Object.assign({}, UITag.defaultProps);
UIAvatarTag.propTypes = Object.assign({}, UITag.propTypes, {
  className: PropTypes.string,
  children: PropTypes.node,
  displayName: PropTypes.string,
  companyId: PropTypes.number,
  email: PropTypes.string,
  domain: PropTypes.string,
  type: PropTypes.string,
  avatarLookup: PropTypes.object,
  src: PropTypes.string,
  lookup: (props, propName) => {
    if (props[propName] && props[propName].length > 1) {
      return new Error('Only one lookup per UIAvatarTag for the moment Please 😥');
    }
    return null;
  }
});
export default UIAvatarTag;